import { Tutorial } from '../tutorial.model';

export const LPS_LISTA_TOUR: Tutorial = {
  id: 'lps-lista',
  rota: '/painel/lancamento-contabil',
  passos: [
    {
      alvo: 'lps-lista.busca',
      titulo: 'Encontre a conta contábil',
      corpo: 'Pesquise pelo nome, pelo código ou por um apelido da conta contábil. A lista é atualizada após a pausa na digitação.',
    },
    {
      alvo: 'lps-lista.filtros',
      titulo: 'Filtre pelo tipo',
      corpo: 'Filtrar abre as opções Todos, Contas a pagar e Contas a receber. A escolha aparece abaixo da busca. Use Limpar ou remova essa indicação para voltar a mostrar os dois tipos.',
    },
    {
      alvo: 'lps-lista.tipo',
      titulo: 'Saiba onde cada conta contábil pode ser usada',
      corpo: 'A coluna Tipo identifica as contas contábeis de Contas a pagar e as de Contas a receber, mesmo quando têm nomes semelhantes. Esse tipo também determina quais categorias podem ser vinculadas à conta contábil.',
    },
    {
      alvo: 'lps-lista.gerenciar',
      titulo: 'Organize os vínculos com as categorias',
      corpo: 'Gerenciar abre o quadro com as contas contábeis de cada categoria, separadas entre contas a pagar e a receber. Lá, você pode reorganizar os vínculos arrastando os cartões.',
    },
    {
      alvo: 'lps-lista.adicionar',
      titulo: 'Adicione uma conta contábil quando precisar',
      corpo: 'Abre o cadastro de uma conta contábil. Confira primeiro o Tipo, depois informe Nome, Código e as categorias correspondentes. Os modelos do onboarding já trazem uma base pronta.',
    },
    {
      alvo: 'lps-lista.visualizar',
      titulo: 'Confira os detalhes e os vínculos da conta contábil',
      corpo: 'O botão de olho abre um resumo com nome, código, tipo, categorias vinculadas, aliases (apelidos) e datas de cadastro e última alteração. A consulta não altera a conta contábil.',
    },
    {
      alvo: 'lps-lista.editar', alvoAlternativo: 'lps-lista.tabela', aguardarAlvo: true,
      titulo: 'Edite o cadastro da conta contábil',
      corpo: 'O lápis abre a edição de Nome, Código e Categorias. O tipo cadastrado permanece identificado na aba Informação; os apelidos de busca ficam na aba Aliases. Use Salvar para gravar as alterações.',
    },
  ],
};
